'use strict';

// 
// Class for managing the mobile menu.
// 

var _ = require('underscore');
var $ = require('./functions');

module.exports = {

	el: $.el('#site-navigation, .site-header-secondary'),

	toggleEl: $.el('.site-navigation-toggle'),

	events: [
		// [ selector, event, callback ]
		['.site-navigation-toggle', 'click', 'toggle'],
	],

	init: function() {
		this.initEvents();
	},

	initEvents: function() {
		_.each(this.events, function(event) {
			$.addEventListener( $.el(event[0]), event[1], _.bind( this[event[2]], this ) );
		}, this);
	},

	close: function() {
		$.removeClass(this.el, 'open');
		$.removeClass(this.toggleEl, 'open');
	},

	on: function(el, eventName, handler) {
		if ( _.isArray(el) ) {
			_.each(el, function(el) {
				this.on(el, eventName, handler);
			}, this);
			return;
		}

		$.addEventListener(el, eventName, handler);
	},

	open: function() {
		$.addClass(this.el, 'open');
		$.addClass(this.toggleEl, 'open');
	},

	toggle: function( event ) {
		if ( $.isVisible(this.el) )
			this.close();
		else
			this.open()
	}

}
